import React, { Component } from "react";

import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { FormattedMessage } from "react-intl";
import "./Distributor.scss";
class ContactWrapper extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {}
  componentDidUpdate(prevProps, prevState, snapshot) {}

  render() {
    return (
      <section id="distributor" className="faq distributor-contact">
        <div className="container">
          <div className="section-title extra">
            <h2 className="title">
              <FormattedMessage id="contact.a13" />
            </h2>
          </div>
          <div className="row">
            <div className="col-lg-6">
              <div className="panel-group accordion" id="distributor-1">
                <div className="panel distributor-panel">
                  <div className="panel-heading">
                    <h4 className="distributor-panel-title">
                      <FormattedMessage id="contact.a62" />
                    </h4>
                    <div className="distributor-desc">
                      <p>
                        <FormattedMessage id="contact.a63" />
                      </p>
                      <p>
                        <FormattedMessage id="contact.a65" />
                        <a
                          href="https://maps.app.goo.gl/BcP1TJkW3mLFdKjbA"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <FormattedMessage id="contact.a64" />
                        </a>
                      </p>
                    </div>
                  </div>
                </div>

                <div className="panel distributor-panel">
                  <div className="panel-heading">
                    <h4 className="distributor-panel-title">
                      <FormattedMessage id="contact.a18" />
                    </h4>
                    <div className="distributor-desc">
                      <p>
                        <FormattedMessage id="contact.a19" />
                      </p>
                      <p>
                        <a
                          href="https://maps.app.goo.gl/dd5YKNeVLdtLEgyZA"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <FormattedMessage id="contact.a20" />
                        </a>
                      </p>
                    </div>
                  </div>
                </div>
                <div className="panel distributor-panel">
                  <div className="panel-heading">
                    <h4 className="distributor-panel-title">
                      <FormattedMessage id="contact.a21" />
                    </h4>
                    <div className="distributor-desc">
                      <p>
                        <FormattedMessage id="contact.a22" />
                      </p>
                      <p>
                        <a
                          href="https://maps.app.goo.gl/Jxb1SL2EmF7usoeo9"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <FormattedMessage id="contact.a23" />
                        </a>
                      </p>
                    </div>
                  </div>
                </div>
                <div className="panel distributor-panel">
                  <div className="panel-heading">
                    <h4 className="distributor-panel-title">
                      <FormattedMessage id="contact.a24" />
                    </h4>
                    <div className="distributor-desc">
                      <p>
                        <FormattedMessage id="contact.a25" />
                      </p>
                      <p>
                        <FormattedMessage id="contact.a65" />
                        <a
                          href="https://maps.app.goo.gl/sgn9G3gxxoMMEsLS8"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <FormattedMessage id="contact.a27" />
                        </a>
                      </p>
                    </div>
                  </div>
                </div>
                <div className="panel distributor-panel">
                  <div className="panel-heading">
                    <h4 className="distributor-panel-title">
                      <FormattedMessage id="contact.a28" />
                    </h4>
                    <div className="distributor-desc">
                      <p>
                        <FormattedMessage id="contact.a29" />
                      </p>
                      <p>
                        <FormattedMessage id="contact.a65" />
                        <a
                          href="https://maps.app.goo.gl/bsMnPQj2zeeXWP2t9"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <FormattedMessage id="contact.a31" />
                        </a>
                      </p>
                    </div>
                  </div>
                </div>
                <div className="panel distributor-panel">
                  <div className="panel-heading">
                    <h4 className="distributor-panel-title">
                      <FormattedMessage id="contact.a32" />
                    </h4>
                    <div className="distributor-desc">
                      <p>
                        <FormattedMessage id="contact.a33" />
                      </p>
                      <p>
                        <FormattedMessage id="contact.a65" />
                        <a
                          href="https://maps.app.goo.gl/B5neYN7MXT4W1gVa6"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <FormattedMessage id="contact.a35" />
                        </a>
                      </p>
                    </div>
                  </div>
                </div>
                <div className="panel distributor-panel">
                  <div className="panel-heading">
                    <h4 className="distributor-panel-title">
                      <FormattedMessage id="contact.a36" />
                    </h4>
                    <div className="distributor-desc">
                      <p>
                        <FormattedMessage id="contact.a37" />
                      </p>
                      <p>
                        <FormattedMessage id="contact.a65" />
                        <a
                          href="https://maps.app.goo.gl/B5neYN7MXT4W1gVa6"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <FormattedMessage id="contact.a39" />
                        </a>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6 d-flex">
              <div className="panel-group accordion" id="distributor-2">
                <div className="panel distributor-panel">
                  <div className="panel-heading">
                    <h4 className="distributor-panel-title">
                      <FormattedMessage id="contact.a14" />
                    </h4>
                    <div className="distributor-desc">
                      <p>
                        <FormattedMessage id="contact.a15" />
                      </p>
                      <p>
                        <FormattedMessage id="contact.a16" />
                        <a
                          href="https://maps.app.goo.gl/h3YY255MUs6RUPqD8"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <FormattedMessage id="contact.a17" />
                        </a>
                      </p>
                    </div>
                  </div>
                </div>
                <div className="panel distributor-panel">
                  <div className="panel-heading">
                    <h4 className="distributor-panel-title">
                      <FormattedMessage id="contact.a40" />
                    </h4>
                    <div className="distributor-desc">
                      <p>
                        <FormattedMessage id="contact.a41" />
                      </p>
                      <p>
                        <a
                          href="https://maps.app.goo.gl/16LKVQsfPyP1txdC8"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <FormattedMessage id="contact.a42" />
                        </a>
                      </p>
                    </div>
                  </div>
                </div>
                <div className="panel distributor-panel">
                  <div className="panel-heading">
                    <h4 className="distributor-panel-title">
                      <FormattedMessage id="contact.a43" />
                    </h4>
                    <div className="distributor-desc">
                      <p>
                        <FormattedMessage id="contact.a44" />
                      </p>
                      <p>
                        <FormattedMessage id="contact.a65" />
                        <a
                          href="https://maps.app.goo.gl/RAsV2DupVhgBdP757"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <FormattedMessage id="contact.a46" />
                        </a>
                      </p>
                    </div>
                  </div>
                </div>
                <div className="panel distributor-panel">
                  <div className="panel-heading">
                    <h4 className="distributor-panel-title">
                      <FormattedMessage id="contact.a47" />
                    </h4>
                    <div className="distributor-desc">
                      <p>
                        <FormattedMessage id="contact.a48" />
                      </p>
                      <p>
                        <FormattedMessage id="contact.a65" />
                        <a
                          href="https://maps.app.goo.gl/RAsV2DupVhgBdP757"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <FormattedMessage id="contact.a50" />
                        </a>
                      </p>
                    </div>
                  </div>
                </div>
                <div className="panel distributor-panel">
                  <div className="panel-heading">
                    <h4 className="distributor-panel-title">
                      <FormattedMessage id="contact.a51" />
                    </h4>
                    <div className="distributor-desc">
                      <p>
                        <FormattedMessage id="contact.a52" />
                      </p>
                      <p>
                        <FormattedMessage id="contact.a65" />
                        <a
                          href="https://maps.app.goo.gl/p2Jtdqevp1fz5mVp7"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <FormattedMessage id="contact.a54" />
                        </a>
                      </p>
                    </div>
                  </div>
                </div>
                <div className="panel distributor-panel">
                  <div className="panel-heading">
                    <h4 className="distributor-panel-title">
                      <FormattedMessage id="contact.a55" />
                    </h4>
                    <div className="distributor-desc">
                      <p>
                        <FormattedMessage id="contact.a56" />
                      </p>
                      <p>
                        <FormattedMessage id="contact.a65" />
                        <a
                          href="https://maps.app.goo.gl/6NjyVsPCpETmmcEn9"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <FormattedMessage id="contact.a58" />
                        </a>
                      </p>
                    </div>
                  </div>
                </div>
                <div className="panel distributor-panel">
                  <div className="panel-heading">
                    <h4 className="distributor-panel-title">
                      <FormattedMessage id="contact.a59" />
                    </h4>
                    <div className="distributor-desc">
                      <p>
                        <FormattedMessage id="contact.a60" />
                      </p>
                      <p>
                        <FormattedMessage id="contact.a65" />
                        <a
                          href="https://maps.app.goo.gl/Q2sMBCdvThFouuqX8"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <FormattedMessage id="contact.a61" />
                        </a>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    language: state.app.language,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ContactWrapper)
);
